import variables from '!!sass-variable-loader!styles/libs/_variables.scss'
export default variables
